export const getFileBinary = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      resolve(reader.result);
    };

    reader.onerror = reject;

    reader.readAsArrayBuffer(file);
  });
};

/**
 * Get the appropriate icon name for a document based on its file extension
 * @param {string} extension - The file extension
 * @returns {string} The icon name
 */
export const getDocumentIconName = (extension) => {
  switch (extension) {
    case 'csv':
      return 'file-name-csv';
    case 'xlsx':
      return 'file-name-xls';
    case 'txt':
      return 'file-name-txt';
    case 'docx':
      return 'file-name-doc';
    case 'pdf':
      return 'file-name-pdf';
    case 'pptx':
      return 'file-name-ppt';
    case 'url':
      return 'site';
    default:
      return 'file-name-json'; // Default icon for unknown types
  }
};

/**
 * Format file size in bytes to human-readable format
 * @param {number} bytes - The file size in bytes
 * @returns {string} The formatted file size
 */
export const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 B';

  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  const size = parseFloat((bytes / Math.pow(k, i)).toFixed(1));
  return `${size} ${sizes[i]}`;
};
